import React, { ReactNode } from 'react';
import { Show } from 'framework/show';
import { useEmployeeService } from 'domain/shared/employee';

interface EmployeeDataProviderProps {
  children: ReactNode;
}

const EmployeeDataProvider: React.FC<EmployeeDataProviderProps> = ({ children }) => {
  const { getCurrentEmployee } = useEmployeeService();

  return <Show getDataMethod={getCurrentEmployee}>{children}</Show>;
};

export default EmployeeDataProvider;
